export const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/i;
export const dateRegex = /^([12]\d{3}-(0[1-9]|1[0-2])-(0[1-9]|[12]\d|3[01]))$/;
export const mobileNumberRegex = /^07\d{9}$/;
